// extracted by mini-css-extract-plugin
export default {"page-settings":"_1pdwqgm","pageSettings":"_1pdwqgm","page-settings-grey":"_1nshqae","pageSettingsGrey":"_1nshqae","no-padding":"_1xmz93k","noPadding":"_1xmz93k"};